import { Component, createRef } from 'react';
import Head from 'next/head'
import Page from '../layouts/main'
import Footer from '../components/Footer/footer.module'
import styles from '../styles/modules/terms-and-conditions.module.scss'
import { TermsConditions as data } from '../util/data'

export default class TermsAndConditions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      analytics: {}
    }
    this.page = createRef();
  }

  componentDidMount() {
    if (this.page.current) {
      this.setState({ ...this.state, analytics: this.page.current.analytics })
    }
  }

  renderItem = (item = {}, index = 0) => {
    switch(item.type) {
      case 'heading':
        return <h4 className={styles['terms-section-heading']} key={ index }> { item.content } </h4>
      case 'paragraph':
        return <p className={`text-body-medium ${styles['terms-section-paragraph']}`} key={ index } dangerouslySetInnerHTML={{ __html: item.content}}></p>
    }
  }

  render() {
    const { analytics } = this.state
    return (
      <Page id={styles['page-terms-and-conditions']} ref={this.page}>
        <Head>
          <title>Terms &amp; Conditions - Kudos Golf</title>
        </Head>

        <section className={`section-content ${styles['section-terms']}`}>
          <h2 className={styles.header}>Terms and Conditions</h2>
          <div className={styles['terms-container']}>
            { data.map((item, index) => this.renderItem(item, index) )}
          </div>
        </section>

        <Footer />
      </Page>
    )
  }
}